<div nz-flex [nzGap]="'small'" [nzVertical]="true">
  <div class="header-wrapper">
    <h1>Lista kont P1</h1>
  </div>

  <nz-table
    #profilesTable
    [nzData]="profiles()"
    [nzBordered]="true"
    [nzLoading]="loading()"
    [nzShowPagination]="false"
    nzTableLayout="fixed"
  >
    <thead>
      <tr>
        <th>Podmiot</th>
        <th>WSS Odcisk palca</th>
        <th>WSS Wygasa o</th>
        <th>TLS Odcisk palca</th>
        <th>TLS Wygasa o</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let profile of profilesTable.data">
        <!--<td>{{ profile.id }}</td>-->

        <td>{{ profile.subject || '-' }}</td>
        <td>{{ profile.wssCertThumbprint || '-' }}</td>
        <td>{{ (profile.wssCertExpiresAt | date: 'yyyy-MM-dd HH:mm') || '-' }}</td>
        <td>{{ profile.tlsCertThumbprint || '-' }}</td>
        <td>{{ (profile.tlsCertExpiresAt | date: 'yyyy-MM-dd HH:mm') || '-' }}</td>
      </tr>
    </tbody>
  </nz-table>
</div>
